const icon = require('./icons/vacant-room-100.png')

export const VacantIcon = () => {
  return <img src={icon} alt="vacant icon" className="w-full h-full"/>
}
